import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CaseStudyIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CaseStudy",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.71 29.29H3.29c-1.89 0-3.43-1.54-3.43-3.43V7.57c0-1.89 1.54-3.43 3.43-3.43h7.05c.3 0 .6-.12.81-.33l.95-.95c.65-.65 1.51-1 2.42-1h6.27c1.89 0 3.43 1.54 3.43 3.43v4.57a1.14 1.14 0 1 1-2.28 0V5.29c0-.63-.51-1.14-1.14-1.14h-6.27c-.31 0-.59.12-.81.33l-.95.95c-.64.64-1.52 1-2.42 1H3.29c-.63 0-1.14.51-1.14 1.14v18.29c0 .63.51 1.14 1.14 1.14h11.43a1.14 1.14 0 1 1 0 2.28Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.94 24.72a1.145 1.145 0 0 1-1.11-1.44l3.22-12.03c.4-1.5 1.76-2.54 3.31-2.54h17.06c1.07 0 2.07.49 2.72 1.34s.87 1.94.59 2.97l-1.06 3.97c-.16.61-.79.97-1.4.81s-.97-.79-.81-1.4l1.06-3.97c.09-.35.02-.71-.2-.99s-.55-.45-.91-.45H11.37c-.52 0-.97.35-1.1.85L7.05 23.87c-.14.51-.6.85-1.1.85ZM28.43 29.29c-.29 0-.58-.11-.81-.33l-4.14-4.14c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l4.14 4.14a1.14 1.14 0 0 1-.81 1.95"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.33 26.79c-3.72 0-6.75-3.03-6.75-6.75s3.03-6.75 6.75-6.75 6.75 3.03 6.75 6.75-3.03 6.75-6.75 6.75m0-11.22c-2.46 0-4.47 2-4.47 4.47s2 4.47 4.47 4.47 4.47-2 4.47-4.47-2-4.47-4.47-4.47"
    })]
  }));
};